import { Text } from '@wework/dieter-ui'
import React from 'react'

export default function BPO({ border, containerStyle = {} }) {
  return (
    <div
      style={{
        position: 'relative',
        padding: 16,
        borderRadius: '.25rem',
        border: border ? '1px solid #E6E6E6' : 0,
        ...containerStyle,
      }}
    >
      <div
        style={{
          border: 0,
        }}
        className="customChip"
      >
        BOOKABLE PRIVATE OFFICE
      </div>
      <Text size="tiny" style={{ marginBottom: 16, marginTop: 12 }}>
        This office is reserved as a bookable private office and currently{' '}
        <b>not for sale.</b> Please refer to{' '}
        <Text
          primary
          size="tiny"
          style={{ display: 'contents', cursor: 'pointer' }}
          as="a"
          target="_blank"
          href="https://connect.weworkers.io/display/WWKB/All+Access+-+Bookable+Private+Office+FAQs"
        >
          connect
        </Text>{' '}
        for more information.
      </Text>
    </div>
  )
}
